import * as routeNames from 'constants/routeNames';
import { VALID_DEEPLINK_ROUTES } from 'constants/deeplink';

export const getValidDeeplinkRoute = (flow: string) => {
  const index = VALID_DEEPLINK_ROUTES.findIndex((route) => route === flow);

  return index >= 0 ? VALID_DEEPLINK_ROUTES[index] : routeNames.DEEPLINK_WARNING;
};
